import { createAction, handleActions } from 'redux-actions';
import { call, put, takeLatest } from 'redux-saga/effects';
import { requestTypeInfo } from 'modules/fetch/api';

const GET_COMPLAINT_TYPE_INFO = 'getType/GET_COMPLAINT_TYPE_INFO';
const COMPLAINT_TYPE_RESULT = 'getType/COMPLAINT_TYPE_RESULT';

export const getComplaintTypeInfo = createAction(GET_COMPLAINT_TYPE_INFO);

export function* getComplaintTypeInfoAction(action) {
  const param = {
    ...action.payload,
  };

  const response = yield call(requestTypeInfo, param);
  yield put({
    type: COMPLAINT_TYPE_RESULT,
    payload: {
      searchText: action.payload.searchText || '',
      typeInfo: response.data || [],
    },
  });
}

export function* getComplaintTypeInfoSaga() {
  yield takeLatest(GET_COMPLAINT_TYPE_INFO, getComplaintTypeInfoAction);
}

const initialState = {
  searchText: '',
  typeInfo: [],
};

export default handleActions(
  {
    [COMPLAINT_TYPE_RESULT]: (state, action) => ({
      ...state,
      typeInfo: action.payload.typeInfo,
    }),
  },
  initialState
);
